{
    "PartitionModal_AddTitle": "Partition hinzufügen",
    "PartitionModal_ChangeTitle": "Partition ändern",
    "PartitionModal_ViewTitle": "Ansichtspartition",
    "PartitionModal_PromptMessage": "Es wurden ungespeicherte Partitionsänderungen vorgenommen. Beenden ohne Speichern?",
    "PartitionModal_PromptConfirm": "Ausfahrt",
    "PartitionModal_PromptCancel": "Stornieren",
    "PartitionModal_Tab_Details": "Details",
    "PartitionModal_Tab_SiteSettings": "Website-Einstellungen",
    "PartitionModal_Tab_Synchronisation": "Synchronisation",
    "PartitionModal_Tab_Advanced": "Fortschrittlich",
    "PartitionModal_Tab_CommunicationStatus": "Synchronisierungsstatus",
    "PartitionModal_Loading": "Laden...",
    "PartitionModal_Button_Close": "Schließen",
    "PartitionModal_Button_Cancel": "Stornieren",
    "PartitionModal_Button_Save": "Speichern",
    "PartitionModal_RequestFailed": "Anfrage fehlgeschlagen",
    "PartitionModal_General_Description": "Beschreibung",
    "PartitionModal_General_DescriptionRequired": "Eine Beschreibung ist erforderlich.",
    "PartitionModal_General_IDInTelSys": "Nr. im Telefonieserver (Auto)",
    "PartitionModal_General_IDInTelSysRequired": "Die Nummer im Telefonieserver ist erforderlich.",
    "PartitionModal_General_Tags": "Etikett",
    "PartitionModal_Details_Identifier": "Kennung",
    "PartitionModal_Details_IdentifierPlaceholder": "[Automatisch zugewiesen]",
    "PartitionModal_Details_BillingIdOrTag": "Rechnungs-ID \/ Tag",
    "PartitionModal_Details_BilledMonthly": "monatliche Abrechnung",
    "PartitionModal_Details_LicensedFor": "Lizenziert für",
    "PartitionModal_Details_DeleteAcdAgentsOnDowngrade": "Automatische Löschung von ACD-Agenteneinträgen",
    "PartitionModal_LicensedFor_None": "Keiner",
    "PartitionModal_LicensedFor_AkixiLite": "Akixi Lite",
    "PartitionModal_LicensedFor_AkixiBLF": "Akixi BLF",
    "PartitionModal_LicensedFor_AkixiONE": "Akixi ONE",
    "PartitionModal_LicensedFor_Akixi1000": "Akixi 1000",
    "PartitionModal_LicensedFor_Enterprise": "Unternehmen",
    "PartitionModal_LicensedFor_Akixi2000": "Akixi 2000",
    "PartitionModal_LicensedFor_Essentials": "Grundlagen",
    "PartitionModal_LicensedFor_Professional": "Professional",
    "PartitionModal_LicensedFor_CallCentreAgent": "Callcenter-Mitarbeiter",
    "PartitionModal_LicensedFor_CallCentreSupervisor": "Callcenter-Supervisor",
    "PartitionModal_Details_CommonDevices": "Enthält gängige Geräte",
    "PartitionModal_Details_CommonDevicesPanasonic": "Enthält gängige Geräte (nur gängige DP)",
    "PartitionModal_Details_CommunicationEnabled": "Kommunikation ermöglicht",
    "PartitionModal_Site_Timezone": "Zeitzone",
    "PartitionModal_Site_StartOfDay": "Tagesbeginn (Ortszeit)",
    "PartitionModal_Site_RecordingPlayback": "Aufnahme-Wiedergabe",
    "PartitionModal_Site_RecordingPlayback_None": "Keiner",
    "PartitionModal_Site_E164Enabled": "E.164-fähig",
    "PartitionModal_Site_InternalDigitLength": "Interne Ziffernlänge",
    "PartitionModal_Site_CountryCodeLocation": "Ländercode Standort",
    "PartitionModal_Sync_NoSettings": "Für diesen Telefonieservertyp gelten keine Synchronisierungseinstellungen.",
    "PartitionModal_Sync_CommonDevicesNoSettings": "Für eine Partition mit gemeinsamen Geräten gelten keine Synchronisierungseinstellungen.",
    "PartitionModal_Sync_NameOnTelephonyServer": "Name auf dem Telefonieserver",
    "PartitionModal_Sync_IDOnTelephonyServerOid": "Kennung auf dem Telefonieserver (OID)",
    "PartitionModal_Sync_SynchronisationTypeSoftOnly": "Synchronisierungstyp (nur Software)",
    "PartitionModal_Sync_EnterpriseOrProviderID": "Unternehmens- oder Anbieter-ID",
    "PartitionModal_Sync_SynchronisationType": "Synchronisationstyp",
    "PartitionModal_Sync_WebexEnvironmentType": "Webex-Umgebungstyp",
    "PartitionModal_Sync_TeamsEnvironmentType": "Teamumgebungstyp",
    "PartitionModal_Sync_EnterpriseID": "Unternehmens-ID",
    "PartitionModal_Sync_GroupID": "Gruppen-ID",
    "PartitionModal_Sync_UserInLocation": "Benutzer am Standort",
    "PartitionModal_Sync_IDOnTelephonyServer": "ID auf dem Telefonieserver",
    "PartitionModal_Sync_TypeOnTelSys": "Geben Sie „Telsys“ ein.",
    "PartitionModal_Sync_WebexTypeEnvironment": "Webex-ähnliche Umgebung",
    "PartitionModal_Sync_ComponentType_Unknown": "[Unbekannter oder nicht spezifizierter Typ]",
    "PartitionModal_Sync_ComponentType_BroadWorks_Enterprise": "Unternehmen",
    "PartitionModal_Sync_ComponentType_BroadWorks_EnterpriseGroup": "Unternehmensgruppe",
    "PartitionModal_Sync_ComponentType_BroadWorks_ServiceProvider": "Dienstleister",
    "PartitionModal_Sync_ComponentType_BroadWorks_ServiceProviderGroup": "Dienstleistergruppe",
    "PartitionModal_Sync_ComponentType_Webex_Organisation": "Organisation",
    "PartitionModal_Sync_ComponentType_Webex_Location": "Standort",
    "PartitionModal_Sync_Environment_None": "Keiner",
    "PartitionModal_Sync_Environment_Tenant": "Mieter",
    "PartitionModal_Sync_Environment_AuthoriserSelect": "Autorisierung auswählen",
    "PartitionModal_Sync_Environment_SecurityGroups": "Sicherheitsgruppen",
    "PartitionModal_Sync_SynchronisationType_Soft": "Weich",
    "PartitionModal_Sync_SynchronisationType_OneTimeFull": "Einmalige volle",
    "PartitionModal_Sync_SynchronisationType_Full": "Voll",
    "PartitionModal_Sync_SynchronisationType_ServicePack": "Servicepaket",
    "PartitionModal_Sync_SecurityGroups": "Sicherheitsgruppen",
    "PartitionModal_Sync_SyncOptions": "Synchronisierungsoptionen",
    "PartitionModal_Sync_SyncOptions_None": "Keiner",
    "PartitionModal_Sync_SyncOptions_Endpoints": "Endpunkte",
    "PartitionModal_Sync_SyncOptions_Trunking": "Kabelkanäle",
    "PartitionModal_Sync_SyncOptions_Agents": "Agenten + zugehörige Nebenstellen",
    "PartitionModal_Sync_SyncOptions_Supervisors": "Vorgesetzte",
    "PartitionModal_Sync_MaintainParity": "Parität wahren",
    "PartitionModal_Sync_ForceMonitored": "Zwangsüberwachung",
    "PartitionModal_Sync_SupervisorPermissions": "Telefonie-Server-Supervisor-Berechtigungen standardmäßig aktivieren",
    "PartitionModal_Sync_SyncNow": "Jetzt synchronisieren",
    "PartitionModal_Sync_PhotoSyncNow": "Fotos jetzt synchronisieren",
    "PartitionModal_Advanced_CtiLoggingEnabled": "CTI-Protokollierung",
    "PartitionModal_Advanced_Trunking": "Kabelkanäle",
    "PartitionModal_Advanced_TrunkingBurst": "Bündelung (Burst)",
    "PartitionModal_Advanced_TrunkingCapacity": "Kabelkanalkapazität",
    "PartitionModal_Advanced_TrunkingCapacityBurst": "Kabelkanalkapazität (Burst)",
    "PartitionModal_Advanced_TrunkCapacity": "Kofferraumkapazität",
    "PartitionModal_Advanced_TrunkCapacityBurst": "Kofferraumkapazität (Burst)",
    "PartitionModal_CommStatus_SyncStatusTitle": "Synchronisierungsstatus",
    "PartitionModal_CommStatus_SyncLastStarted": "Zuletzt gestartet um:",
    "PartitionModal_CommStatus_SyncLastStarted_Placeholder": "—",
    "PartitionModal_CommStatus_SyncLastError": "Synchronisierungsstatus \/ Fehler",
    "PartitionModal_CommStatus_SyncLastError_Placeholder": "Es ist noch kein Synchronisierungsstatus verfügbar.",
    "NAME": "PartitionModal"
}